import { ReactNode } from "react";

export function PageGrid({ children }: { children: ReactNode }) {
  return <div className="grid gap-y-5">{children}</div>;
}
